module.exports = __webpack_public_path__ + "img/party-2017-study.ebf5138d.jpg";